import type { FuriganaMode } from "@/hooks/use-furigana-preference"

function getRubyBase(ruby: Element): string {
  return Array.from(ruby.childNodes)
    .filter((n) => n.nodeType === Node.TEXT_NODE)
    .map((n) => n.textContent ?? "")
    .join("")
}

export function processStoryHtml(
  html: string,
  mode: FuriganaMode,
  firstOnly: boolean,
  knownKanji: string[]
): string {
  const doc = new DOMParser().parseFromString(`<div>${html}</div>`, "text/html")
  const seen = new Set<string>()

  for (const ruby of doc.querySelectorAll("ruby")) {
    const base = getRubyBase(ruby)
    const rt = ruby.querySelector("rt")
    const rps = ruby.querySelectorAll("rp")
    if (!rt) continue

    let show = true

    if (mode === "all") {
      show = true
    } else if (mode === "none") {
      show = false
    } else if (mode === "unknown") {
      if (base === "") continue

      show = base.split("").some((kanji) => !knownKanji.includes(kanji))
    }

    if (show && firstOnly) {
      if (seen.has(base)) show = false
    }

    if (base) seen.add(base)

    ruby.dataset.showFurigana = show ? "1" : "0"

    if (!show) {
      ;(rt as HTMLElement).style.opacity = "0"
      for (const rp of rps) {
        ;(rp as HTMLElement).style.opacity = "0"
      }
    }
  }

  return doc.querySelector("div")!.innerHTML
}
